module.exports = __webpack_public_path__ + "static/media/mit.ac9a2a86.png";